import React from "react";
import APIEndPoints from "../../utils/APIEndPoints";
import AppIcons from "../../utils/AppIcons";
import { useApiClient } from "../../contexts/ApiClientContext";
import DownloadCode from "../../model/DownloadCode";

interface IFormDownloadFileProps {
  file_name: string | undefined;
  file_upload_id: number;
  label?: string | undefined;
  warning_message?: string | undefined;
}

function FormDownloadFile({
  label = "",
  file_name,
  file_upload_id,
  warning_message = "",
}: IFormDownloadFileProps) {
  const aText = file_name ? file_name : "click here to download";

  // reference to the ApiClient instance
  const apiClient = useApiClient();

  const getDownloadCode = async (id: number) => {
    const responseData = await apiClient?.get<DownloadCode>({
      url: APIEndPoints.DOWNLOADS.CODE(id),
      requiresToken: true,
    });
    window.location.href = APIEndPoints.DOWNLOADS.FILE(
      responseData.download_code
    );
  };

  return (
    <div>
      {label && <label className="form-label">{label}</label>}
      <a
        className="form-download-file"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          getDownloadCode(file_upload_id);
        }}
        download={file_name}
      >
        {AppIcons.DOWNLOAD}
        {aText}
      </a>
      {warning_message && <div className="form-warning">{warning_message}</div>}
    </div>
  );
}

export default FormDownloadFile;
